import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useCallback, useState, useMemo } from 'react';
import { useWeb5Context } from "../../../../../lib/Web5Context";
import { getUploadDescriptor, createImport, updateUploadDescriptor, updateImport } from "../../../../../lib/services/imports";
import { uploadToS3 } from "../../../../../lib/services/files";
import { showErrorToast } from "../../../../../lib/errors";
import { ENTITIES } from "../../../../../lib/constants";
import { publish } from "../../../../../lib/EventBuser";
import { REFRESH_IMPORT_LIST } from "../../../../../lib/events";
const initialState = {
  file: null,
  errors: null
};
const useUploadFile = _ref => {
  let {
    data,
    entityName,
    getFieldsList,
    maxImportColumns,
    maxImportRows,
    onChange,
    onComplete,
    matchBy,
    shrinkedTab,
    currentStep,
    onBack,
    entityLogName,
    language
  } = _ref;
  const {
    t,
    logEvent
  } = useWeb5Context();
  const [file, setFile] = useState((data === null || data === void 0 ? void 0 : data.file) || initialState.file);
  const [isUploadingOpen, setIsUploadingOpen] = useState(false);
  const [errors, setErrors] = useState(initialState.errors);
  const [gettingFields, setGettingFields] = useState(false);
  useEffect(() => {
    var _data$syncNamesMatch;
    if (gettingFields || errors || !data.columns) return;
    const newErrors = [];
    if ((data === null || data === void 0 ? void 0 : data.columns) > maxImportColumns) {
      newErrors.push(t('cfm_error_import_too_many_fields', [maxImportColumns]));
    }
    if ((data === null || data === void 0 ? void 0 : data.rows) > maxImportRows) {
      newErrors.push(t('cfm_error_import_too_many_registers', [maxImportRows]));
    }
    if (data !== null && data !== void 0 && (_data$syncNamesMatch = data.syncNamesMatch) !== null && _data$syncNamesMatch !== void 0 && _data$syncNamesMatch.length) {
      setGettingFields(true);
      const _getFieldsList = () => data.fields ? Promise.resolve(data.fields) : getFieldsList(entityName);
      _getFieldsList().then(fields => {
        if (fields) {
          const syncNamesMatch = data === null || data === void 0 ? void 0 : data.syncNamesMatch.map(id => id === 'id' ? t('cfm_label_id') : fields.find(el => id === el.value).label);
          newErrors.push(t('cfm_error_import_update_1', [syncNamesMatch.join(', ')]));
        }
        setErrors(newErrors);
      }).catch(error => {
        console.error(error);
      });
    } else {
      setErrors(newErrors);
    }
  }, [data.columns, data.fields, data === null || data === void 0 ? void 0 : data.rows, data === null || data === void 0 ? void 0 : data.syncNamesMatch, entityName, errors, getFieldsList, gettingFields, maxImportColumns, maxImportRows, t]);
  const handleOnBack = useCallback(() => {
    onChange({
      file: null
    });
    setFile(initialState.file);
    setErrors(initialState.errors);
    onBack();
  }, [setFile, setErrors, onBack, onChange]);

  // File
  const onDrop = useCallback(acceptedFiles => {
    setFile(acceptedFiles[0]);
  }, []);
  const onRemove = useCallback(() => {
    setFile(null);
    onChange({
      file: null
    });
  }, [onChange]);

  // Uploading modal

  const onContinue = useCallback(() => {
    const fileName = file.name;
    if (file === data.file) {
      if (data.importType === 'create') {
        logEvent({
          event: entityLogName,
          submodule: entityName,
          functionality: 'importCreateUploadFile'
        });
      } else {
        logEvent({
          event: entityLogName,
          submodule: entityName,
          functionality: 'importUpdateUploadFile'
        });
      }
      return onComplete({});
    }
    const getDescriptor = data.file && data.id ? d => updateUploadDescriptor(data.id, d) : d => getUploadDescriptor(d);
    let generateImport;
    if (data.file && data.id) {
      generateImport = d => updateImport(data.id, d);
    } else {
      generateImport = d => {
        if (matchBy) {
          if (entityName === ENTITIES.CONTACTS.name) {
            d.matchingRelated = {
              idempresa: parseInt(matchBy, 10)
            };
          } else if (entityName === ENTITIES.OPPORTUNITIES.name) {
            d.matchingRelated = {
              idconstructora: parseInt(matchBy, 10),
              idingenieria: parseInt(matchBy, 10),
              idinstalador: parseInt(matchBy, 10)
            };
          }
        }
        return createImport(d);
      };
    }
    getDescriptor({
      // Get upload descriptor
      name: fileName,
      resource: shrinkedTab ? shrinkedTab === null || shrinkedTab === void 0 ? void 0 : shrinkedTab.value : entityName
    }).then(result => {
      // Independent upload to S3
      setIsUploadingOpen(true);
      return uploadToS3(result.data.url, file).then(() => result);
    }).then((result // Generate import with upload file
    ) => generateImport({
      name: fileName,
      resource: shrinkedTab ? shrinkedTab === null || shrinkedTab === void 0 ? void 0 : shrinkedTab.value : entityName,
      type: data.importType,
      syncNames: data.syncNames,
      bucket: result.data.bucket,
      key: result.data.key,
      language: language,
      mandatoryExtraFields: data.matchMandatoryExtra,
      mandatoryStandardFields: data.matchMandatoryStandard,
      matchMandatory: data.matchMandatory
    })).then(result => {
      if (data.importType === 'create') {
        logEvent({
          event: entityLogName,
          submodule: entityName,
          functionality: 'importCreateUploadFile'
        });
      } else {
        logEvent({
          event: entityLogName,
          submodule: entityName,
          functionality: 'importUpdateUploadFile'
        });
      }
      const resultData = result ? result.data || {} : {};
      setIsUploadingOpen(false);
      onComplete(_objectSpread(_objectSpread({}, resultData), {}, {
        state: 1,
        file,
        syncNamesMatch: null
      }));
      publish(REFRESH_IMPORT_LIST);
    }).catch(error => {
      console.error(error);
      showErrorToast(t, error);
      setIsUploadingOpen(false);
    });
  }, [file, data, onComplete, shrinkedTab, entityName, language, t, matchBy, logEvent, entityLogName]);
  const uploadDescriptionLabel = useMemo(() => {
    if ((data === null || data === void 0 ? void 0 : data.importType) === 'create') return 'cfm_label_upload_file_desc';
    return 'cfm_label_upload_file_desc_update';
  }, [data === null || data === void 0 ? void 0 : data.importType]);
  const uploadFileProps = useMemo(() => ({
    uploadDescriptionLabel,
    file,
    onRemove,
    onDrop
  }), [uploadDescriptionLabel, file, onRemove, onDrop]);
  const uploadFileHeaderProps = useMemo(() => ({
    errors
  }), [errors]);
  const uploadFileFooterProps = useMemo(() => ({
    onConfirm: onContinue,
    isConfirmDisabled: !file
  }), [onContinue, file]);
  if (currentStep !== 2) return {};
  return {
    uploadFileProps,
    uploadFileHeaderProps,
    uploadFileFooterProps,
    isUploadingOpen,
    onBackUploadFile: handleOnBack
  };
};
export default useUploadFile;